const NEW_STUDENT_PORTAL_FROM = new Date('2026-05-21T00:00:00.000Z');

// Cohorts migrated to the new student portal before the default start-date cutoff.
export const NEW_STUDENT_PORTAL_ALLOWLIST = new Set([
  '685430ae896c45002b039818',
  '69721373b947e3906ebe4db2',
  '6985cc3cb947e3906ebe4dbc',
  '6985cd78b947e3906ebe4dbd',
  '68d6784b8514f3002b50ef89',
  '68d6781c1a783e002b5a877f',
  '68d676984af4c5002b18547c',
  '68ed179d5bb77a002b7acd47',
  '68ed179a24a650002b9ef67f',
  '68ed2726ebb924002b822a07',
  '68ed276824a650002b9ef686',
  '68ed2760ebb924002b822a09',
  '68ed27715bb77a002b7acd56',
  '68ed277b5bb77a002b7acd59',
  '68ed277f1c68c3002bfab213',
  '68ed27791c68c3002bfab211',
  '68ed278f1c68c3002bfab215',
  '68ed27401c68c3002bfab20b',
  '68ed27615bb77a002b7acd50',
  '68ed276d5bb77a002b7acd53',
  '68ed276e5bb77a002b7acd54',
  '68ed277224a650002b9ef687',
  '68ed277cebb924002b822a0f',
  '68ed278224a650002b9ef689',
  '68ed278124a650002b9ef688',
  '68ed278924a650002b9ef68c',
  '68ed2790ebb924002b822a16',
  '68e3b1dbef1579002b0b7d7d',
  '68ed27765bb77a002b7acd58',
  '68ed2780ebb924002b822a11',
  '68ed27941c68c3002bfab216',
  '68ed16915bb77a002b7acd46',
  '68ed17961c68c3002bfab200',
  '68ed17a01c68c3002bfab201',
  '68ed17a31c68c3002bfab202',
  '68ed17a41c68c3002bfab203',
  '68ed273a5bb77a002b7acd4e',
  '68ffad32fd64b4002b849cf8',
  '68ffad35c7e719002b1ce2e4',
  '68ffacd34fa762002bd859d8',
  '68ffad24c7e719002b1ce2de',
  '68ffad264fa762002bd859d9',
  '68ffad27c7e719002b1ce2df',
  '68ffad28c7e719002b1ce2e0',
  '68ed2756ebb924002b822a08',
  '68ed275a5bb77a002b7acd4f',
  '68ed2765ebb924002b822a0b',
  '68ed276724a650002b9ef685',
  '68ed27691c68c3002bfab20d',
  '68ed276a5bb77a002b7acd51',
  '68ed279124a650002b9ef690',
  '68ed279224a650002b9ef691',
  '68ffad294fa762002bd859da',
  '68ffad2ac7e719002b1ce2e1',
  '68ffad2bc7e719002b1ce2e2',
  '68ffad2cc7e719002b1ce2e3',
  '68ed276b1c68c3002bfab20e',
  '68ed276c5bb77a002b7acd52',
  '68ed276f1c68c3002bfab20f',
  '68ed27705bb77a002b7acd55',
  '68ed2773ebb924002b822a0c',
  '68ed27745bb77a002b7acd57',
  '68ed27751c68c3002bfab210',
  '68ed277a1c68c3002bfab212',
  '68ed2778ebb924002b822a0e',
  '68ed277debb924002b822a10',
  '68ed277e5bb77a002b7acd5a',
  '68ed27845bb77a002b7acd5b',
  '68ed2786ebb924002b822a13',
  '68ffad334fa762002bd859dd',
  '68ffad34fd64b4002b849cf9',
  '68ffad2dfd64b4002b849cf6',
  '68ffad2efd64b4002b849cf7',
  '68ffad304fa762002bd859db',
  '68ffad314fa762002bd859dc',
  '68ed2777ebb924002b822a0d',
  '68ed278824a650002b9ef68b',
  '68ed27881c68c3002bfab214',
  '68ed2783ebb924002b822a12',
  '68ed278524a650002b9ef68a',
  '68ed2787ebb924002b822a14',
  '68ed278aebb924002b822a15',
  '68ed278b5bb77a002b7acd5c',
  '68ed278c24a650002b9ef68d',
  '68ed278d24a650002b9ef68e',
  '68ed278e24a650002b9ef68f',
  '68ed27935bb77a002b7acd5d',
  '69c1259b2d38cb002b10c2df',
  '69c52740f2ce69002b97ad14',
  '69cbb0bb635c5f002b299dc5',
  '69c52982f2ce69002b97ad15',
  '69c527d1533532002b42a354',
  '64144b52ffbfc4002a67478c',
  '69d8ea9e9cbd98002beb2690',
  '69d8eb3ee9fd40002b0224a6',
  '6985ef16da306f002b4fb64e',
  '698d934637e964002b9e4a9e',
  '69c52bec3a91d7002b447e67',
  '69c52cb52afadf002b53d1b4',
]);

const NEW_STUDENT_PORTAL_BLOCKLIST = new Set([]);

function isStartDateOnOrAfter(startDate, cutoff) {
  if (!startDate) return false;

  return new Date(startDate) >= cutoff;
}

export function hasNewStudentPortal(cohortId, startDate) {
  const isExplicitlyBlocked = NEW_STUDENT_PORTAL_BLOCKLIST.has(cohortId);
  if (isExplicitlyBlocked) return false;

  const isExplicitlyAllowed = NEW_STUDENT_PORTAL_ALLOWLIST.has(cohortId);
  const passesStartDateCutoff = isStartDateOnOrAfter(
    startDate,
    NEW_STUDENT_PORTAL_FROM,
  );

  return isExplicitlyAllowed || passesStartDateCutoff;
}
